import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { RootErrorBoundary } from './components/errors';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker, isPushSupported, isNativeApp, initNativeListeners } from './utils/pushNotifications';
import { isPublicBookingPath, isPublicOrderPath, isPublicChatPath, isPublicFinishPath } from './utils/publicBookingPath';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </React.StrictMode>
);

// Push notification bootstrapping.
//
// Web:    Register the service worker so it's ready when the user opts in.
//         Listen for SW-→page nav messages and forward as window events.
// Native: Register Capacitor push listeners so notification taps route the
//         user to the right channel — including when the app starts from a
//         tap on a notification while it was fully killed (Capacitor replays
//         queued events after listeners bind, so we must bind early).
if (isNativeApp()) {
  initNativeListeners();
} else if (!isPublicBookingPath(window.location.pathname) && !isPublicOrderPath(window.location.pathname) && !isPublicChatPath(window.location.pathname) && !isPublicFinishPath(window.location.pathname)) {
  // Not for the website's booking form (/book), a customer's order link (/o/…) or the website chat (/chat): none has
  // notifications to receive, or staff work to keep for no signal. The service worker also keeps the app's own files
  // so Chariot opens with no signal (orders overhaul Phase 4), so it registers wherever service workers exist.
  registerServiceWorker();

  if (isPushSupported()) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data?.type === 'push:navigate' && event.data.url) {
        window.dispatchEvent(new CustomEvent('chariot:push-navigate', {
          detail: { url: event.data.url },
        }));
      }
    });
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
